import { createI18n } from 'vue-i18n';
import zh from './zh.json';
import en from './en.json';
import store from "@/store";
const i18n = createI18n({
    locale: store.getGlobalState('language'),
    allowComposition: true,
    globalInjection: true,
    // legacy: false, // 允许 Vue I18n 切换 API 模式，从 Legacy API 模式到 Composition API 模式。
    messages: {
        zh,
        en,
    },
});
export default i18n;
